// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Course Player Styles */
.course-player {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #f8f9fa;
  }
  
  /* Header */
  .course-player-header {
    background-color: #295478;
    padding: 1rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #2c4a6b;
  }
  
  .course-player-header .btn-link {
    color: white;
    text-decoration: none;
    padding: 0;
  }
  
  .course-player-header .btn-link:hover {
    color: #ccc;
  }
  
  /* Body */
  .course-player-body {
    display: flex;
    flex: 1 1;
    overflow: hidden;
  }
  
  /* Sidebar */
  .course-player-sidebar {
    width: 350px;
    background-color: white;
    border-right: 1px solid #e9ecef;
    display: flex;
    flex-direction: column;
    transition: left 0.3s ease;

  }
  
  .sidebar-header {
    padding: 1rem 1.5rem;
    border-bottom: 1px solid #e9ecef;
    background-color: #f8f9fa;
  }
  
  .sidebar-content {
    flex: 1 1;
    overflow-y: auto;
    padding: 0;
  }
  
  .module-section {
    border-bottom: 1px solid #f0f0f0;
  }
  
  .module-header {
    padding: 1rem 1.5rem;
    background-color: #f8f9fa;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .module-header:hover {
    background-color: #e9ecef;
  }
  
  .module-title {
    font-weight: 500;
    color: #333;
    font-size: 0.9rem;
  }
  
  .module-progress {
    font-size: 0.8rem;
    color: #6c757d;
  }
  
  .lessons-list {
    background-color: white;
  }
  
  .lesson-item {
    padding: 0.75rem 1.5rem;
    cursor: pointer;
    transition: background-color 0.3s ease;
    border-bottom: 1px solid #f8f9fa;
  }
  
  .lesson-item:hover {
    background-color: #f8f9fa;
  }
  
  .lesson-item.active {
    background-color: #e3f2fd;
    border-left: 3px solid #1e3a5f;
  }
  
  .lesson-title {
    font-size: 0.85rem;
    color: #555;
    line-height: 1.4;
  }
  
  .lesson-duration {
    font-size: 0.75rem;
    color: #6c757d;
  }
  
  /* Main Content */
  .course-player-main {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
  
  /* Lesson Viewer */
  .lesson-viewer {
    flex: 1 1;
    display: flex;
    flex-direction: column;
  }
  
  .lesson-tabs {
    display: flex;
    background-color: white;
    border-bottom: 1px solid #e9ecef;
    padding: 0 1rem;
  }
  
  .lesson-tab {
    background: none;
    border: none;
    padding: 1rem 1.5rem;
    color: #6c757d;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    border-bottom: 3px solid transparent;
  }
  
  .lesson-tab:hover {
    color: #333;
  }
  
  .lesson-tab.active {
    color: #1e3a5f;
    border-bottom-color: #1e3a5f;
  }
  
  .lesson-content {
    flex: 1 1;
    padding: 2rem;
    overflow-y: auto;
  }
  
  /* Video Container */
  .video-container {
    position: relative;
    background-color: #000;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 1rem;
  }
  
  .powerpoint-viewer {
    position: relative;
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .powerpoint-slide {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  
  .zoom-overlay {
    position: absolute;
    top: 1rem;
    right: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .zoom-participants {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .participant {
    display: flex;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 0.5rem;
    border-radius: 4px;
    font-size: 0.8rem;
  }
  
  .participant img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 0.5rem;
  }
  
  .lesson-note {
    text-align: center;
    padding: 1rem;
    background-color: #f8f9fa;
    border-radius: 6px;
  }
  
  /* Overview Tab */
  .overview-content {
    max-width: 800px;
    font-size: 1rem;
    line-height: 1.6;
    color: #555;
  }
  
  /* Exercise Files Tab */
  .files-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 1rem;
  }
  
  .file-card {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 1.5rem;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  
  .file-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
  
  .file-icon {
    font-size: 2rem;
  }
  
  .file-info {
    flex: 1 1;
  }
  
  .file-name {
    font-size: 0.9rem;
    font-weight: 500;
    margin-bottom: 0.25rem;
  }
  
  .file-size {
    font-size: 0.8rem;
  }
  
  .download-icon {
    font-size: 1.2rem;
  }
  
  /* Quiz Viewer */
  .quiz-viewer {
    padding: 2rem;
  }
  
  .quiz-header-info {
    margin-bottom: 2rem;
  }
  
  .quiz-type {
    background-color: #e9ecef;
    color: #6c757d;
    padding: 0.25rem 0.75rem;
    border-radius: 4px;
    font-size: 0.8rem;
    font-weight: 500;
  }
  
  .quiz-title {
    margin-top: 0.5rem;
    color: #333;
  }
  
  .quiz-stats {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 1.5rem;
    margin-bottom: 2rem;
  }
  
  .stat-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .stat-label {
    font-weight: 500;
    color: #6c757d;
  }
  
  .stat-value {
    font-weight: 600;
    color: #333;
  }
  
  .quiz-attempts {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 1.5rem;
    margin-bottom: 2rem;
  }
  
  .quiz-attempts table {
    margin-bottom: 0;
  }
  
  .quiz-attempts th {
    font-size: 0.85rem;
    font-weight: 600;
    color: #6c757d;
    border-bottom: 2px solid #e9ecef;
  }
  
  .quiz-attempts td {
    font-size: 0.85rem;
    vertical-align: middle;
  }
  
  /* Quiz Taking */
  .quiz-header {
    background: white;
    border-bottom: 1px solid #e9ecef;
    padding: 1rem 2rem;
  }
  
  .quiz-info {
    display: flex;
    align-items: center;
    font-size: 0.9rem;
    color: #6c757d;
  }
  
  .question-section {
    max-width: 800px;
  }
  
  .question-title {
    color: #333;
    margin-bottom: 2rem;
    font-weight: 600;
  }
  
  .options-grid {
    margin-bottom: 2rem;
  }
  
  .option-card {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 1rem;
    transition: all 0.3s ease;
    height: 100%;
  }
  
  .option-card:hover {
    border-color: #b8860b;
    box-shadow: 0 2px 8px rgba(184, 134, 11, 0.1);
  }
  
  .option-card .form-check-input:checked {
    background-color: #b8860b;
    border-color: #b8860b;
  }
  
  .option-card .form-check-label {
    font-size: 0.9rem;
    line-height: 1.4;
    cursor: pointer;
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .course-player-sidebar {
      width: 80%;
      max-width: 320px;
      position: fixed;
      top: 0;
      left: -100%;
      height: 100vh;
      z-index: 1050;
      transition: left 0.3s ease-in-out;
      box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
    }
  
    .course-player-sidebar.open {
      left: 0;
    }
  
    .sidebar-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1040;
    }
  
    .course-player-header {
      padding: 0.75rem 1rem;
    }
  
    .lesson-content,
    .quiz-viewer {
      padding: 1rem;
    }
  
    .files-grid {
      grid-template-columns: 1fr;
    }
  
    .quiz-stats .row {
      flex-direction: column;
    }
  
    .quiz-stats .col-md-3 {
      margin-bottom: 1rem;
    }
  
    .options-grid .col-md-6 {
      margin-bottom: 1rem;
    }
  }
  
  @media (max-width: 576px) {
    .course-player-header h5 {
      font-size: 1rem;
    }
  
    .course-player-header span {
      font-size: 0.8rem;
    }
  
    .lesson-tabs {
      overflow-x: auto;
    }
  
    .lesson-tab {
      white-space: nowrap;
      padding: 0.75rem 1rem;
    }
  
    .quiz-attempts {
      overflow-x: auto;
    }
  
    .quiz-attempts table {
      min-width: 600px;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/course-player.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA,WAAW;EACX;IACE,yBAAyB;IACzB,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,YAAY;IACZ,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA,SAAS;EACT;IACE,aAAa;IACb,SAAO;IACP,gBAAgB;EAClB;;EAEA,YAAY;EACZ;IACE,YAAY;IACZ,uBAAuB;IACvB,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,0BAA0B;;EAE5B;;EAEA;IACE,oBAAoB;IACpB,gCAAgC;IAChC,yBAAyB;EAC3B;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,sCAAsC;IACtC,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA,iBAAiB;EACjB;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,cAAc;EAChB;;EAEA,kBAAkB;EAClB;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,oCAAoC;EACtC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,4BAA4B;EAC9B;;EAEA;IACE,SAAO;IACP,aAAa;IACb,gBAAgB;EAClB;;EAEA,oBAAoB;EACpB;IACE,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA,iBAAiB;EACjB;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA,uBAAuB;EACvB;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,yCAAyC;IACzC,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,gBAAgB;EAChB;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA,gBAAgB;EAChB;IACE,iBAAiB;IACjB,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;;EAEA,sBAAsB;EACtB;IACE;MACE,UAAU;MACV,gBAAgB;MAChB,eAAe;MACf,MAAM;MACN,WAAW;MACX,aAAa;MACb,aAAa;MACb,iCAAiC;MACjC,wCAAwC;IAC1C;;IAEA;MACE,OAAO;IACT;;IAEA;MACE,eAAe;MACf,MAAM;MACN,OAAO;MACP,YAAY;MACZ,aAAa;MACb,8BAA8B;MAC9B,aAAa;IACf;;IAEA;MACE,qBAAqB;IACvB;;IAEA;;MAEE,aAAa;IACf;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;EACF;;EAEA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,mBAAmB;MACnB,qBAAqB;IACvB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;EACF","sourcesContent":["/* Course Player Styles */\n.course-player {\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    background-color: #f8f9fa;\n  }\n  \n  /* Header */\n  .course-player-header {\n    background-color: #295478;\n    padding: 1rem 1.5rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #2c4a6b;\n  }\n  \n  .course-player-header .btn-link {\n    color: white;\n    text-decoration: none;\n    padding: 0;\n  }\n  \n  .course-player-header .btn-link:hover {\n    color: #ccc;\n  }\n  \n  /* Body */\n  .course-player-body {\n    display: flex;\n    flex: 1;\n    overflow: hidden;\n  }\n  \n  /* Sidebar */\n  .course-player-sidebar {\n    width: 350px;\n    background-color: white;\n    border-right: 1px solid #e9ecef;\n    display: flex;\n    flex-direction: column;\n    transition: left 0.3s ease;\n\n  }\n  \n  .sidebar-header {\n    padding: 1rem 1.5rem;\n    border-bottom: 1px solid #e9ecef;\n    background-color: #f8f9fa;\n  }\n  \n  .sidebar-content {\n    flex: 1;\n    overflow-y: auto;\n    padding: 0;\n  }\n  \n  .module-section {\n    border-bottom: 1px solid #f0f0f0;\n  }\n  \n  .module-header {\n    padding: 1rem 1.5rem;\n    background-color: #f8f9fa;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .module-header:hover {\n    background-color: #e9ecef;\n  }\n  \n  .module-title {\n    font-weight: 500;\n    color: #333;\n    font-size: 0.9rem;\n  }\n  \n  .module-progress {\n    font-size: 0.8rem;\n    color: #6c757d;\n  }\n  \n  .lessons-list {\n    background-color: white;\n  }\n  \n  .lesson-item {\n    padding: 0.75rem 1.5rem;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    border-bottom: 1px solid #f8f9fa;\n  }\n  \n  .lesson-item:hover {\n    background-color: #f8f9fa;\n  }\n  \n  .lesson-item.active {\n    background-color: #e3f2fd;\n    border-left: 3px solid #1e3a5f;\n  }\n  \n  .lesson-title {\n    font-size: 0.85rem;\n    color: #555;\n    line-height: 1.4;\n  }\n  \n  .lesson-duration {\n    font-size: 0.75rem;\n    color: #6c757d;\n  }\n  \n  /* Main Content */\n  .course-player-main {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: auto;\n  }\n  \n  /* Lesson Viewer */\n  .lesson-viewer {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .lesson-tabs {\n    display: flex;\n    background-color: white;\n    border-bottom: 1px solid #e9ecef;\n    padding: 0 1rem;\n  }\n  \n  .lesson-tab {\n    background: none;\n    border: none;\n    padding: 1rem 1.5rem;\n    color: #6c757d;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border-bottom: 3px solid transparent;\n  }\n  \n  .lesson-tab:hover {\n    color: #333;\n  }\n  \n  .lesson-tab.active {\n    color: #1e3a5f;\n    border-bottom-color: #1e3a5f;\n  }\n  \n  .lesson-content {\n    flex: 1;\n    padding: 2rem;\n    overflow-y: auto;\n  }\n  \n  /* Video Container */\n  .video-container {\n    position: relative;\n    background-color: #000;\n    border-radius: 8px;\n    overflow: hidden;\n    margin-bottom: 1rem;\n  }\n  \n  .powerpoint-viewer {\n    position: relative;\n    height: 500px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .powerpoint-slide {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n  \n  .zoom-overlay {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .zoom-participants {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .participant {\n    display: flex;\n    align-items: center;\n    background-color: rgba(0, 0, 0, 0.7);\n    color: white;\n    padding: 0.5rem;\n    border-radius: 4px;\n    font-size: 0.8rem;\n  }\n  \n  .participant img {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    margin-right: 0.5rem;\n  }\n  \n  .lesson-note {\n    text-align: center;\n    padding: 1rem;\n    background-color: #f8f9fa;\n    border-radius: 6px;\n  }\n  \n  /* Overview Tab */\n  .overview-content {\n    max-width: 800px;\n    font-size: 1rem;\n    line-height: 1.6;\n    color: #555;\n  }\n  \n  /* Exercise Files Tab */\n  .files-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 1rem;\n  }\n  \n  .file-card {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 8px;\n    padding: 1.5rem;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n  }\n  \n  .file-card:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    transform: translateY(-2px);\n  }\n  \n  .file-icon {\n    font-size: 2rem;\n  }\n  \n  .file-info {\n    flex: 1;\n  }\n  \n  .file-name {\n    font-size: 0.9rem;\n    font-weight: 500;\n    margin-bottom: 0.25rem;\n  }\n  \n  .file-size {\n    font-size: 0.8rem;\n  }\n  \n  .download-icon {\n    font-size: 1.2rem;\n  }\n  \n  /* Quiz Viewer */\n  .quiz-viewer {\n    padding: 2rem;\n  }\n  \n  .quiz-header-info {\n    margin-bottom: 2rem;\n  }\n  \n  .quiz-type {\n    background-color: #e9ecef;\n    color: #6c757d;\n    padding: 0.25rem 0.75rem;\n    border-radius: 4px;\n    font-size: 0.8rem;\n    font-weight: 500;\n  }\n  \n  .quiz-title {\n    margin-top: 0.5rem;\n    color: #333;\n  }\n  \n  .quiz-stats {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 8px;\n    padding: 1.5rem;\n    margin-bottom: 2rem;\n  }\n  \n  .stat-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .stat-label {\n    font-weight: 500;\n    color: #6c757d;\n  }\n  \n  .stat-value {\n    font-weight: 600;\n    color: #333;\n  }\n  \n  .quiz-attempts {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 8px;\n    padding: 1.5rem;\n    margin-bottom: 2rem;\n  }\n  \n  .quiz-attempts table {\n    margin-bottom: 0;\n  }\n  \n  .quiz-attempts th {\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: #6c757d;\n    border-bottom: 2px solid #e9ecef;\n  }\n  \n  .quiz-attempts td {\n    font-size: 0.85rem;\n    vertical-align: middle;\n  }\n  \n  /* Quiz Taking */\n  .quiz-header {\n    background: white;\n    border-bottom: 1px solid #e9ecef;\n    padding: 1rem 2rem;\n  }\n  \n  .quiz-info {\n    display: flex;\n    align-items: center;\n    font-size: 0.9rem;\n    color: #6c757d;\n  }\n  \n  .question-section {\n    max-width: 800px;\n  }\n  \n  .question-title {\n    color: #333;\n    margin-bottom: 2rem;\n    font-weight: 600;\n  }\n  \n  .options-grid {\n    margin-bottom: 2rem;\n  }\n  \n  .option-card {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 8px;\n    padding: 1rem;\n    transition: all 0.3s ease;\n    height: 100%;\n  }\n  \n  .option-card:hover {\n    border-color: #b8860b;\n    box-shadow: 0 2px 8px rgba(184, 134, 11, 0.1);\n  }\n  \n  .option-card .form-check-input:checked {\n    background-color: #b8860b;\n    border-color: #b8860b;\n  }\n  \n  .option-card .form-check-label {\n    font-size: 0.9rem;\n    line-height: 1.4;\n    cursor: pointer;\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .course-player-sidebar {\n      width: 80%;\n      max-width: 320px;\n      position: fixed;\n      top: 0;\n      left: -100%;\n      height: 100vh;\n      z-index: 1050;\n      transition: left 0.3s ease-in-out;\n      box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);\n    }\n  \n    .course-player-sidebar.open {\n      left: 0;\n    }\n  \n    .sidebar-overlay {\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100vw;\n      height: 100vh;\n      background: rgba(0, 0, 0, 0.5);\n      z-index: 1040;\n    }\n  \n    .course-player-header {\n      padding: 0.75rem 1rem;\n    }\n  \n    .lesson-content,\n    .quiz-viewer {\n      padding: 1rem;\n    }\n  \n    .files-grid {\n      grid-template-columns: 1fr;\n    }\n  \n    .quiz-stats .row {\n      flex-direction: column;\n    }\n  \n    .quiz-stats .col-md-3 {\n      margin-bottom: 1rem;\n    }\n  \n    .options-grid .col-md-6 {\n      margin-bottom: 1rem;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .course-player-header h5 {\n      font-size: 1rem;\n    }\n  \n    .course-player-header span {\n      font-size: 0.8rem;\n    }\n  \n    .lesson-tabs {\n      overflow-x: auto;\n    }\n  \n    .lesson-tab {\n      white-space: nowrap;\n      padding: 0.75rem 1rem;\n    }\n  \n    .quiz-attempts {\n      overflow-x: auto;\n    }\n  \n    .quiz-attempts table {\n      min-width: 600px;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
